module.exports = __webpack_public_path__ + "static/img/qxb.6605b84.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/qxb.png
// module id = UCoC
// module chunks = 2